import { Box, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const GradientBackground = styled(Box)(({ theme, color = 'primary' }) => ({
  background: `linear-gradient(135deg, ${alpha(theme.palette[color].main, 0.1)} 0%, ${alpha(theme.palette[color].light, 0.05)} 100%)`,
  borderRadius: theme.shape.borderRadius * 2,
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    width: '40%',
    height: '100%',
    background: `radial-gradient(circle at top right, ${alpha(theme.palette[color].main, 0.08)}, transparent 70%)`,
    pointerEvents: 'none',
  },
}));

export const MetricValueDisplay = styled(Typography)(({ theme }) => ({
  fontWeight: 800,
  fontSize: '2rem',
  lineHeight: 1.1,
  background: `linear-gradient(135deg, ${theme.palette.text.primary} 0%, ${alpha(theme.palette.text.primary, 0.7)} 100%)`,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  [theme.breakpoints.up('sm')]: {
    fontSize: '2.5rem',
  },
}));